import { IAnalyzerBannerConfig } from "src/app/element-components/analyzer-banner/analyzer-banner/analyzer-banner.component";
import { IChipConfig } from "src/app/element-components/chips/chips.component";
import { PageId } from "src/app/models/portal.model";

export class ApplicationState {
	public navigationHistory!: ApplicationStateNavigationHistory;
	public pageId?: PageId;
	public pageTitle?: string
	public pageSection?: string
	public chipActive?: IChipConfig
	public analyzerBanner?: IAnalyzerBannerConfig
}

export class ApplicationStateNavigationHistory {
	public previous!: { url: string, position: [number, number] }[];
	public current?: { url: string, position: [number, number] };
	public fowards!: { url: string, position: [number, number] }[];
}

export const applicationInitialState: ApplicationState = {
	navigationHistory: { previous: [], current: undefined, fowards: [] },
	pageId: "home"
};
